module.exports = __webpack_public_path__ + "img/bt_Casino_def.2bb993e1.png";